import { Component, Input } from '@angular/core';
import { AiChatMessage } from '../models/ai-message.model';

@Component({
  selector: 'app-ai-chat-message',
  templateUrl: './ai-chat-message.component.html',
  styleUrls: ['./ai-chat-message.component.css']
})
export class AiChatMessageComponent {

  @Input() readonly message: AiChatMessage;
  
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/ai-chat-message/ai-chat-message.component.ts